const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Ungültige Eingabe für Minimum und Maximum.',
    invalid_options: 'Ungültige Feldoptionen.',
    invalid_regex_format: 'Ungültiges Regex-Format.',
    invalid_address_parts: 'Ungültige Adressbestandteile.',
    invalid_fullname_parts: 'Ungültige Vor- und Nachnamenangaben.',
    name_exists: 'Ein Feld mit diesem Namen existiert bereits.',
    conflicted_sie_order: 'Konflikt im Feldreihenfolgewert für die Sign-in Experience.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
